export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_RESPONSE = 'GET_USERS_RESPONSE';
export const GET_USERS_RESPONSE_ERROR = 'GET_USERS_RESPONSE_ERROR';
export const SWITCH_TYPE_OF_USER = 'SWITCH_TYPE_OF_USER';
export const GET_STATES_REQUEST = 'GET_STATES_REQUEST';
export const GET_STATES_RESPONSE = 'GET_STATES_RESPONSE';
export const GET_STATES_RESPONSE_ERROR = 'GET_STATES_RESPONSE_ERROR';
export const GET_REGIONS_REQUEST = 'GET_REGIONS_REQUEST';
export const GET_REGIONS_RESPONSE = 'GET_REGIONS_RESPONSE';
export const GET_REGIONS_RESPONSE_ERROR = 'GET_REGIONS_RESPONSE_ERROR';
export const GET_BRANCHES_REQUEST = 'GET_BRANCHES_REQUEST';
export const GET_BRANCHES_RESPONSE = 'GET_BRANCHES_RESPONSE';
export const GET_BRANCHES_RESPONSE_ERROR = 'GET_BRANCHES_RESPONSE_ERROR';
export const GET_BRANCHES_PROVIDERS_REQUEST = 'GET_BRANCHES_PROVIDERS_REQUEST';
export const GET_BRANCHES_PROVIDERS_RESPONSE = 'GET_BRANCHES_PROVIDERS_RESPONSE';
export const GET_BRANCHES_PROVIDERS_RESPONSE_ERROR = 'GET_BRANCHES_PROVIDERS_RESPONSE_ERROR';
export const GET_PROVIDERS_REQUEST = 'GET_PROVIDERS_REQUEST';
export const GET_PROVIDERS_RESPONSE = 'GET_PROVIDERS_RESPONSE';
export const GET_PROVIDERS_RESPONSE_ERROR = 'GET_PROVIDERS_RESPONSE_ERROR';
export const GET_PROVIDERS_ME_REQUEST = 'GET_PROVIDERS_ME_REQUEST';
export const GET_PROVIDERS_ME_RESPONSE = 'GET_PROVIDERS_ME_RESPONSE';
export const GET_PROVIDERS_ME_RESPONSE_ERROR = 'GET_PROVIDERS_ME_RESPONSE_ERROR';
export const SET_PROVIDER_SELECTED = 'SET_PROVIDER_SELECTED';
export const CLEAN_ATTENTION_FOR_CREATE = 'CLEAN_ATTENTION_FOR_CREATE';
export const SET_ADMIN_SELECTED = 'SET_ADMIN_SELECTED';
export const ADD_PROVIDER_REQUEST = 'ADD_PROVIDER_REQUEST';
export const ADD_PROVIDER_RESPONSE = 'ADD_PROVIDER_RESPONSE';
export const ADD_PROVIDER_RESPONSE_ERROR = 'ADD_PROVIDER_RESPONSE_ERROR';
export const ADD_ADMIN_REQUEST = 'ADD_ADMIN_REQUEST';
export const ADD_ADMIN_RESPONSE = 'ADD_ADMIN_RESPONSE';
export const ADD_ADMIN_RESPONSE_ERROR = 'ADD_ADMIN_RESPONSE_ERROR';
export const PUT_PROVIDER_REQUEST = 'PUT_PROVIDER_REQUEST';
export const PUT_PROVIDER_RESPONSE = 'PUT_PROVIDER_RESPONSE';
export const PUT_PROVIDER_RESPONSE_ERROR = 'PUT_PROVIDER_RESPONSE_ERROR';
export const DELETE_PROVIDER_REQUEST = 'DELETE_PROVIDER_REQUEST';
export const DELETE_PROVIDER_RESPONSE = 'DELETE_PROVIDER_RESPONSE';
export const DELETE_PROVIDER_RESPONSE_ERROR = 'DELETE_PROVIDER_RESPONSE_ERROR';
export const PUT_ADMIN_REQUEST = 'PUT_ADMIN_REQUEST';
export const PUT_ADMIN_RESPONSE = 'PUT_ADMIN_RESPONSE';
export const PUT_ADMIN_RESPONSE_ERROR = 'PUT_ADMIN_RESPONSE_ERROR';
export const SET_NAME = 'SET_NAME';
export const SORT_USER_LIST = 'SORT_USER_LIST';
export const FILTER_USER_LIST = 'FILTER_USER_LIST';
export const CLEAN_EDIT_USER_STATE = 'CLEAN_EDIT_USER_STATE';
export const CLEAN_NEW_PROVIDER_STATE = 'CLEAN_NEW_PROVIDER_STATE';
export const CLEAN_NEW_ADMIN_STATE = 'CLEAN_NEW_ADMIN_STATE';
export const SET_LIST_CONFIG = 'SET_LIST_CONFIG';
export const SELECT_SELF = 'SELECT_SELF';
export const SELECT_SELF_RESPONSE = 'SELECT_SELF_RESPONSE';
export const SELECT_SELF_RESPONSE_ERROR = 'SELECT_SELF_RESPONSE_ERROR';
export const PUT_CHANGE_PASSWORD_REQUEST = 'PUT_CHANGE_PASSWORD_REQUEST';
export const PUT_CHANGE_PASSWORD_RESPONSE = 'PUT_CHANGE_PASSWORD_RESPONSE';
export const RESET_CHANGE_PASSWORD_STATE = 'RESET_CHANGE_PASSWORD_STATE';
export const PUT_CHANGE_PASSWORD_RESPONSE_ERROR = 'PUT_CHANGE_PASSWORD_RESPONSE_ERROR';
export const GET_AFFILIATE_REQUEST = 'GET_AFFILIATE_REQUEST';
export const GET_AFFILIATE_RESPONSE = 'GET_AFFILIATE_RESPONSE';
export const GET_AFFILIATE_RESPONSE_ERROR = 'GET_AFFILIATE_RESPONSE_ERROR';
export const GET_PLANS_REQUEST = 'GET_PLANS_REQUEST';
export const GET_PLANS_RESPONSE = 'GET_PLANS_RESPONSE';
export const GET_PLANS_RESPONSE_ERROR = 'GET_PLANS_RESPONSE_ERROR';
export const GET_MEDICAL_SERVICES_REQUEST = 'GET_MEDICAL_SERVICES_REQUEST';
export const GET_MEDICAL_SERVICES_RESPONSE = 'GET_MEDICAL_SERVICES_RESPONSE';
export const GET_MEDICAL_SERVICES_RESPONSE_ERROR = 'GET_MEDICAL_SERVICES_RESPONSE_ERROR';
export const GET_ALL_MEDICAL_SERVICES_REQUEST = 'GET_ALL_MEDICAL_SERVICES_REQUEST';
export const GET_ALL_MEDICAL_SERVICES_RESPONSE = 'GET_ALL_MEDICAL_SERVICES_RESPONSE';
export const GET_ALL_MEDICAL_SERVICES_RESPONSE_ERROR = 'GET_ALL_MEDICAL_SERVICES_RESPONSE_ERROR';
export const APPROVE_ATTENTION_REQUEST = 'APPROVE_ATTENTION_REQUEST';
export const APPROVE_ATTENTION_RESPONSE = 'APPROVE_ATTENTION_RESPONSE';
export const APPROVE_ATTENTION_RESPONSE_ERROR = 'APPROVE_ATTENTION_RESPONSE_ERROR';
export const CREATE_ATTENTION_REQUEST = 'CREATE_ATTENTION_REQUEST';
export const CREATE_ATTENTION_RESPONSE = 'CREATE_ATTENTION_RESPONSE';
export const CREATE_ATTENTION_RESPONSE_ERROR = 'CREATE_ATTENTION_RESPONSE_ERROR';
export const CLEAN_APPROVE_ATTENTION_STATE = 'CLEAN_APPROVE_ATTENTION_STATE';
export const CLEAN_ATTENTION = 'CLEAN_ATTENTION';
export const CLEAN_AFFILIATES = 'CLEAN_AFFILIATES';
export const CLEAN_USERS = 'CLEAN_USERS';
export const CLEAN_GET_BRANCHES_STATE = 'CLEAN_GET_BRANCHES_STATE';
export const SET_AFFILIATE_SELECTED = 'SET_AFFILIATE_SELECTED';
export const SET_ATTENTION_FOR_CREATE = 'SET_ATTENTION_FOR_CREATE';
export const CLEAN_BRANCHES = 'CLEAN_BRANCHES';
export const CLEAN_PROVIDERS_BRANCHES = 'CLEAN_PROVIDERS_BRANCHES';
export const CLEAN_SELECT_SELF = 'CLEAN_SELECT_SELF';
export const GET_ALL_ATTENTIONS_REQUEST = 'GET_ALL_ATTENTIONS_REQUEST';
export const GET_ALL_ATTENTIONS_DOWNLOAD_REQUEST = 'GET_ALL_ATTENTIONS_DOWNLOAD_REQUEST';
export const GET_ALL_ATTENTIONS_DOWNLOAD_RESPONSE = 'GET_ALL_ATTENTIONS_DOWNLOAD_RESPONSE';
export const GET_ALL_ATTENTIONS_RESPONSE = 'GET_ALL_ATTENTIONS_RESPONSE';
export const GET_ALL_ATTENTIONS_RESPONSE_ERROR = 'GET_ALL_ATTENTIONS_RESPONSE_ERROR';
export const DELETE_ADMIN_REQUEST = 'DELETE_ADMIN_REQUEST';
export const DELETE_ADMIN_RESPONSE = 'DELETE_ADMIN_RESPONSE';
export const DELETE_ADMIN_RESPONSE_ERROR = 'DELETE_ADMIN_RESPONSE_ERROR';
export const DELETE_ATTENTION_REQUEST = 'DELETE_ATTENTION_REQUEST';
export const DELETE_ATTENTION_RESPONSE = 'DELETE_ATTENTION_RESPONSE';
export const CLEAR_DELETE_ATTENTION_STATE = 'CLEAR_DELETE_ATTENTION_STATE';
export const DELETE_ATTENTION_RESPONSE_ERROR = 'DELETE_ATTENTION_RESPONSE_ERROR';
export const SELECT_PLAN = 'SELECT_PLAN';
export const CLEAN_CREATE_ATTENTION_STATE = 'CLEAN_CREATE_ATTENTION_STATE';
export const SEND_QUOTE_EMAIL_REQUEST = 'SEND_QUOTE_EMAIL_REQUEST';
export const SEND_QUOTE_EMAIL_RESPONSE = 'SEND_QUOTE_EMAIL_RESPONSE';
export const SEND_QUOTE_EMAIL_RESPONSE_ERROR = 'SEND_QUOTE_EMAIL_RESPONSE_ERROR';
export const CLEAN_SEND_QUOTE_EMAIL_STATE = 'CLEAN_SEND_QUOTE_EMAIL_STATE';
export const CLEAN_GET_AFFILIATES_STATE = 'CLEAN_GET_AFFILIATES_STATE';
export const CLEAN_LIST_CONFIG = 'CLEAN_LIST_CONFIG';
export const SET_ATTENTIONS_SELECTED = 'SET_ATTENTIONS_SELECTED';
export const CLEAN_ATTENTIONS_SELECTED = 'CLEAN_ATTENTIONS_SELECTED';
export const BULK_INSERT = 'BULK_INSERT';
export const BULK_INSERT_RESPONSE = 'BULK_INSERT_RESPONSE';
export const BULK_INSERT_RESPONSE_ERROR = 'BULK_INSERT_RESPONSE_ERROR';
export const CLEAN_BULK_INSERT = 'CLEAN_BULK_INSERT';
export const GET_AMOUNT_LIST_REQUEST = 'GET_AMOUNT_LIST_REQUEST';
export const GET_AMOUNT_LIST_RESPONSE = 'GET_AMOUNT_LIST_RESPONSE';
export const GET_AMOUNT_LIST_RESPONSE_ERROR = 'GET_AMOUNT_LIST_RESPONSE_ERROR';
export const GET_ALL_AMOUNTS_DOWNLOAD_REQUEST = 'GET_ALL_AMOUNTS_DOWNLOAD_REQUEST';
export const GET_ALL_AMOUNTS_DOWNLOAD_RESPONSE = 'GET_ALL_AMOUNTS_DOWNLOAD_RESPONSE';
export const GET_ALL_AMOUNTS_DOWNLOAD_ERROR = 'GET_ALL_AMOUNTS_DOWNLOAD_ERROR';
export const GET_ALL_DOWNLOADED_ATTENTIONS_STATE = 'GET_ALL_DOWNLOADED_ATTENTIONS_STATE';
export const CLEAN_AMOUNT_LIST_STATE = 'CLEAN_AMOUNT_STATE';
export const SET_BRANCH_AND_PROVIDER = 'SET_BRANCH_AND_PROVIDER';

// [MODULE_ACTIONS] EXPORT ACTION

const homeActions = {
    switchOfUser: (name) => ({type: SWITCH_TYPE_OF_USER, name}),
    setName: (name) => ({type: SET_NAME, name}),
    setBranchAndProvider: (branch, provider) => ({type: SET_BRANCH_AND_PROVIDER, branch, provider}),

    getUsersRequest: () => ({type: GET_USERS_REQUEST}),
    getUsersResponse: (response) => ({type: GET_USERS_RESPONSE, response}),
    getUsersResponseError: (error) => ({type: GET_USERS_RESPONSE_ERROR, error}),

    getStatesRequest: () => ({type: GET_STATES_REQUEST}),
    getStatesResponse: (response) => ({type: GET_STATES_RESPONSE, response: response}),
    getStatesResponseError: (error) => ({type: GET_STATES_RESPONSE_ERROR, error}),
    getRegionsRequest: () => ({type: GET_REGIONS_REQUEST}),
    getRegionsResponse: (response) => ({type: GET_REGIONS_RESPONSE, response: response}),
    getRegionsResponseError: (error) => ({type: GET_REGIONS_RESPONSE_ERROR, error}),
    getBranchesRequest: () => ({type: GET_BRANCHES_REQUEST}),
    getBranchesResponse: (response) => ({type: GET_BRANCHES_RESPONSE, response: response}),
    getBranchesResponseError: (error) => ({type: GET_BRANCHES_RESPONSE_ERROR, error}),
    getBranchesProvidersRequest: (id) => ({type: GET_BRANCHES_PROVIDERS_REQUEST, id}),
    getBranchesProvidersResponse: (response) => ({type: GET_BRANCHES_PROVIDERS_RESPONSE, response: response}),
    getBranchesProvidersResponseError: (error) => ({type: GET_BRANCHES_PROVIDERS_RESPONSE_ERROR, error}),
    getProvidersRequest: () => ({type: GET_PROVIDERS_REQUEST}),
    getProvidersResponse: (response) => ({type: GET_PROVIDERS_RESPONSE, response: response}),
    getProvidersResponseError: (error) => ({type: GET_PROVIDERS_RESPONSE_ERROR, error}),
    getProvidersMeRequest: (body) => ({type: GET_PROVIDERS_ME_REQUEST, body}),
    getProvidersMeResponse: (response) => ({type: GET_PROVIDERS_ME_RESPONSE, response: response}),
    getProvidersMeResponseError: (error) => ({type: GET_PROVIDERS_ME_RESPONSE_ERROR, error}),
    setProviderSelected: (providerSelected) => ({type: SET_PROVIDER_SELECTED, providerSelected}),
    setAdminSelected: (adminSelected) => ({type: SET_ADMIN_SELECTED, adminSelected}),
    addProviderRequest: (provider) => ({type: ADD_PROVIDER_REQUEST, body: provider}),
    addProviderResponse: (response) => ({type: ADD_PROVIDER_RESPONSE, response: response}),
    addProviderResponseError: (error) => ({type: ADD_PROVIDER_RESPONSE_ERROR, error}),
    putProviderRequest: (body) => ({type: PUT_PROVIDER_REQUEST, body}),
    putProviderResponse: (response) => ({type: PUT_PROVIDER_RESPONSE, response: response}),
    putProviderResponseError: (error) => ({type: PUT_PROVIDER_RESPONSE_ERROR, error}),
    deleteProviderRequest: (id, providerType) => ({type: DELETE_PROVIDER_REQUEST, id, providerType}),
    deleteProviderResponse: (response) => ({type: DELETE_PROVIDER_RESPONSE, response: response}),
    deleteProviderResponseError: (error) => ({type: DELETE_PROVIDER_RESPONSE_ERROR, error}),
    deleteAdminRequest: (id, providerType) => ({type: DELETE_ADMIN_REQUEST, id, providerType}),
    deleteAdminResponse: (response) => ({type: DELETE_ADMIN_RESPONSE, response: response}),
    deleteAdminResponseError: (error) => ({type: DELETE_ADMIN_RESPONSE_ERROR, error}),
    addAdminRequest: (provider) => ({type: ADD_ADMIN_REQUEST, body: provider}),
    addAdminResponse: (response) => ({type: ADD_ADMIN_RESPONSE, response: response}),
    addAdminResponseError: (error) => ({type: ADD_ADMIN_RESPONSE_ERROR, error}),
    putAdminRequest: (body) => ({type: PUT_ADMIN_REQUEST, body}),
    putAdminResponse: (response) => ({type: PUT_ADMIN_RESPONSE, response: response}),
    putAdminResponseError: (error) => ({type: PUT_ADMIN_RESPONSE_ERROR, error}),
    cleanEditUserState: () => ( {type: CLEAN_EDIT_USER_STATE} ),
    cleanNewProviderState: () => ({type: CLEAN_NEW_PROVIDER_STATE}),
    cleanNewAdminState: () => ({type: CLEAN_NEW_ADMIN_STATE}),
    setListConfig: (body) => ({type: SET_LIST_CONFIG, body}),
    cleanListConfig: (list) => ({type: CLEAN_LIST_CONFIG, list}),
    selectSelf: () => ({type: SELECT_SELF}),
    selectSelfResponse: (response) => ({type: SELECT_SELF_RESPONSE, response}),
    selectSelfResponseError: (error) => ({type: SELECT_SELF_RESPONSE_ERROR, error}),
    putChangePasswordRequest: (body) => ({type: PUT_CHANGE_PASSWORD_REQUEST, body}),
    putChangePasswordResponse: (response) => ({type: PUT_CHANGE_PASSWORD_RESPONSE, response: response}),
    resetChangePasswordState: () => ({type: RESET_CHANGE_PASSWORD_STATE}),
    putChangePasswordResponseError: (error) => ({type: PUT_CHANGE_PASSWORD_RESPONSE_ERROR, error}),
    cleanAffiliates: () => ({type: CLEAN_AFFILIATES}),
    cleanUsers: () => ({type: CLEAN_USERS}),
    cleanGetBranchesState: () => ({type: CLEAN_GET_BRANCHES_STATE}),
    getAffiliateRequest: (document, documentType) => ({type: GET_AFFILIATE_REQUEST, document, documentType}),
    getAffiliateResponse: (response) => ({type: GET_AFFILIATE_RESPONSE, response: response}),
    getAffiliateResponseError: (error) => ({type: GET_AFFILIATE_RESPONSE_ERROR, error}),
    getPlansRequest: () => ({type: GET_PLANS_REQUEST}),
    getPlansResponse: (response) => ({type: GET_PLANS_RESPONSE, response: response}),
    getPlansResponseError: (error) => ({type: GET_PLANS_RESPONSE_ERROR, error}),
    getMedicalServicesRequest: (plans) => ({type: GET_MEDICAL_SERVICES_REQUEST, plans}),
    getMedicalServicesResponse: (response) => ({type: GET_MEDICAL_SERVICES_RESPONSE, response: response}),
    getMedicalServicesResponseError: (error) => ({type: GET_MEDICAL_SERVICES_RESPONSE_ERROR, error}),
    getAllMedicalServicesRequest: () => ({type: GET_ALL_MEDICAL_SERVICES_REQUEST}),
    getAllMedicalServicesResponse: (response) => ({type: GET_ALL_MEDICAL_SERVICES_RESPONSE, response: response}),
    getAllMedicalServicesResponseError: (error) => ({type: GET_ALL_MEDICAL_SERVICES_RESPONSE_ERROR, error}),
    approveAttentionRequest: (body) => ({type: APPROVE_ATTENTION_REQUEST, body}),
    approveAttentionResponse: (response) => ({type: APPROVE_ATTENTION_RESPONSE, response: response}),
    approveAttentionResponseError: (error) => ({type: APPROVE_ATTENTION_RESPONSE_ERROR, error}),
    createAttentionRequest: (body) => ({type: CREATE_ATTENTION_REQUEST, body}),
    createAttentionResponse: (response) => ({type: CREATE_ATTENTION_RESPONSE, response: response}),
    createAttentionResponseError: (error) => ({type: CREATE_ATTENTION_RESPONSE_ERROR, error}),
    cleanCreateAttentionState: () => ({type: CLEAN_CREATE_ATTENTION_STATE}),
    sendQuoteEmailRequest: (body) => ({type: SEND_QUOTE_EMAIL_REQUEST, body}),
    sendQuoteEmailResponse: (response) => ({type: SEND_QUOTE_EMAIL_RESPONSE, response}),
    sendQuoteEmailResponseError: (error) => ({type: SEND_QUOTE_EMAIL_RESPONSE_ERROR, error}),
    cleanSendQuoteEmailState: () => ({type: CLEAN_SEND_QUOTE_EMAIL_STATE}),
    cleanApproveAttentionState: () => ({type: CLEAN_APPROVE_ATTENTION_STATE}),
    cleanAttention: () => ({type: CLEAN_ATTENTION}),
    cleanBranches: () => ({type: {CLEAN_BRANCHES}}),
    cleanProvidersBranches: () => ({type: CLEAN_PROVIDERS_BRANCHES}),
    cleanSelectSelf: () => ({type: CLEAN_SELECT_SELF}),
    setAffiliateSelected: (affiliate) => ({type: SET_AFFILIATE_SELECTED, affiliate}),
    setAttentionForCreate: (attention) => ({type: SET_ATTENTION_FOR_CREATE, attention}),
    cleanAttentionForCreate: () => ({type: CLEAN_ATTENTION_FOR_CREATE}),
    getAllAttentionsRequest: () => ({type: GET_ALL_ATTENTIONS_REQUEST}),
    getAllAttentionsDownloadRequest: () => ({type: GET_ALL_ATTENTIONS_DOWNLOAD_REQUEST}),
    getAllAttentionsDownloadResponse: (response) => ({type: GET_ALL_ATTENTIONS_DOWNLOAD_RESPONSE, response: response}),
    getAllDownloadedAttentionsState: () => ({type: GET_ALL_DOWNLOADED_ATTENTIONS_STATE}),
    getAllAttentionsResponse: (response) => ({type: GET_ALL_ATTENTIONS_RESPONSE, response: response}),
    getAllAttentionsResponseError: (error) => ({type: GET_ALL_ATTENTIONS_RESPONSE_ERROR, error}),
    deleteAttentionRequest: (body) => ({type: DELETE_ATTENTION_REQUEST, body}),
    deleteAttentionResponse: (response) => ({type: DELETE_ATTENTION_RESPONSE, response: response}),
    clearDeleteAttentionState: () => ({type: CLEAR_DELETE_ATTENTION_STATE}),
    deleteAttentionResponseError: (error) => ({type: DELETE_ATTENTION_RESPONSE_ERROR, error}),
    selectPlan: (plan) => ({type: SELECT_PLAN, plan}),
    cleanGetAffiliatesState: () => ({type: CLEAN_GET_AFFILIATES_STATE}),
    setAttentionsSelected: (attentionsSelected) => ({type: SET_ATTENTIONS_SELECTED, attentionsSelected}),
    cleanAttentionsSelected: () => ({type: CLEAN_ATTENTIONS_SELECTED}),
    bulkInsert: (body) => ({type: BULK_INSERT, body}),
    bulkInsertResponse: (response) => ({type: BULK_INSERT_RESPONSE, response}),
    bulkInsertResponseError: (error) => ({type: BULK_INSERT_RESPONSE_ERROR, error}),
    cleanBulkInsert: () => ({type: CLEAN_BULK_INSERT}),
    getAmountListRequest: () => ({type: GET_AMOUNT_LIST_REQUEST}),
    getAmountListResponse: (response) => ({type: GET_AMOUNT_LIST_RESPONSE, response: response}),
    getAmountListResponseError: (error) => ({type: GET_AMOUNT_LIST_RESPONSE_ERROR, error}),
    getAllAmountsToDownloadRequest: () => ({type: GET_ALL_AMOUNTS_DOWNLOAD_REQUEST}),
    getAllAmountsToDownloadResponse: (response) => ({type: GET_ALL_AMOUNTS_DOWNLOAD_RESPONSE, response}),
    createAllAmountsToDownloadError: (error) => ({type: GET_ALL_AMOUNTS_DOWNLOAD_ERROR, error}),
    cleanAmountListState: () => ({type: CLEAN_AMOUNT_LIST_STATE}),
    // [MODULE_ACTIONS] DEFINE NEW ACTIONS
};

export default homeActions;
